import { FEEDBACK_TAGS, FEEDBACK_TAG_LABELS, type FeedbackTag } from '@pomoshnik/shared';

/**
 * UI-layer re-export словаря тегов Block 10 (PRD §14, ADR-0018 §Q2).
 *
 * Прозрачная обёртка вокруг `@pomoshnik/shared` — позволяет UI features
 * импортировать из feature-папки, а не из shared, и хранить здесь любые
 * UI-specific helpers (например, `getFeedbackTagEntries` для удобного `.map()`
 * в JSX).
 *
 * Pattern идентичен Block 2/4 (handles/decors KindPicker re-exports).
 */

export { FEEDBACK_TAGS, FEEDBACK_TAG_LABELS, type FeedbackTag };

/** Возвращает массив `[tag, label]` для UI map (Presenter рендерит чипы). */
export function getFeedbackTagEntries(): Array<[FeedbackTag, string]> {
  return FEEDBACK_TAGS.map((tag) => [tag, FEEDBACK_TAG_LABELS[tag]]);
}
